// ipad-pwa/src/lib/datetime.js
// 24-hour time helpers. Always uses the browser's local zone (the iPad is
// physically in the same building as the IPT, so its local zone matches
// the universal app timezone for any practical deployment).

const pad = (n) => String(n).padStart(2, '0');

function asDate(d) {
  if (!d) return null;
  if (d instanceof Date) return Number.isNaN(d.getTime()) ? null : d;
  const x = new Date(d);
  return Number.isNaN(x.getTime()) ? null : x;
}

export function fmtTime(d) {
  const x = asDate(d);
  if (!x) return '';
  return `${pad(x.getHours())}:${pad(x.getMinutes())}`;
}

export function fmtClock(d) {
  const x = asDate(d) || new Date();
  return `${pad(x.getHours())}:${pad(x.getMinutes())}:${pad(x.getSeconds())}`;
}

export function fmtDate(d) {
  const x = asDate(d);
  if (!x) return '';
  return `${x.getFullYear()}-${pad(x.getMonth() + 1)}-${pad(x.getDate())}`;
}

// Friendly date used in the kiosk top-bar, e.g. "Mon, 26 May 2026".
const _WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const _MONTHS = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
];
export function fmtDateLong(d) {
  const x = asDate(d) || new Date();
  return `${_WEEKDAYS[x.getDay()]}, ${x.getDate()} ${_MONTHS[x.getMonth()]} ${x.getFullYear()}`;
}

export function fmtElapsed(fromIso) {
  const from = asDate(fromIso);
  if (!from) return '00:00:00';
  const sec = Math.max(0, Math.floor((Date.now() - from.getTime()) / 1000));
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  const s = sec % 60;
  return `${pad(h)}:${pad(m)}:${pad(s)}`;
}

// Client-side rounded slot preview — mirrors @iptbc/session-rounding
// roundSignIn / roundSignOut rules so the kiosk can show "slot starts 13:00"
// while the user is still on the sign-in screen.
export function roundSignInHour(d) {
  const x = asDate(d) || new Date();
  let h = x.getHours();
  if (x.getMinutes() >= 45) h += 1;
  return (h + 24) % 24;
}
export function roundSignOutHour(d) {
  const x = asDate(d) || new Date();
  let h = x.getHours();
  // Any minute or second past HH:00 means the pilot has entered slot
  // HH and therefore "used" it for billing — round UP. Only HH:00:00
  // exact stays on HH. Mirrors shared/sessionRounding/index.js.
  if (x.getMinutes() > 0 || x.getSeconds() > 0) h += 1;
  return (h + 24) % 24;
}
